import React from 'react';
import PropTypes from 'prop-types';
import Info from './Info';

const Component = props => {
    const { show, title, description, colors } = props.settings;
    return (
        <>
            {show && (
                <div style={{ marginBottom: '2em' }}>
                    <Info title={title} content={description} colors={colors} />
                </div>
            )}
        </>
    );
};

Component.propTypes = {
    settings: PropTypes.object,
    isPreview: PropTypes.bool,
    filters: PropTypes.object,
};

Component.defaultProps = {
    filters: {},
};

export default Component;
